import React, { memo, useCallback } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { CustomToolTip } from './CustomToolTip';
import './DonutChart.scss';

export const DonutChart = memo(({ used, remaining, chartLabels }) => {
    const safeRemaining = remaining > 0 ? remaining : 0;
    const isEmpty = !used && !safeRemaining;

    const data = [
        { name: chartLabels.completed, value: used, color: 'var(--chart-color-completed)' },
        { name: chartLabels.available, value: safeRemaining, color: 'var(--chart-color-remaining)' },
    ];

    const renderCustomizedLabel = useCallback(({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return value > 0 ? (
            <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize={14}>
                {value}
            </text>
        ) : null;
    }, []);

    if (isEmpty) return null;

    return (
        <PieChart width={420} height={250}>
            <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
                innerRadius={60}
                startAngle={90}
                endAngle={-270}
                label={renderCustomizedLabel}
                labelLine={false}
            >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
            </Pie>
            <Tooltip content={<CustomToolTip />} />
            <Legend
                verticalAlign="middle"
                align="right"
                layout="vertical"
                className="donut-legend"
                formatter={(value) => <span className="donut-legend-label">{value}</span>}
            />
        </PieChart>
    );
});
